/* Mad Hatter Co. — Paper Nav Behaviour
   Mega hover · Expanding search + Predictive Search API
   Mobile takeover · Slim-on-scroll · Cart badge bounce
   ---------------------------------------------------------------- */
(function () {
  'use strict';

  /* ── Selectors ── */
  const HDR       = document.getElementById('MHSiteHeader');
  const BURGER    = document.getElementById('MHBurger');
  const MM        = document.getElementById('MHMobileMenu');
  const MM_CLOSE  = document.getElementById('MHMobileClose');
  const MM_INPUT  = document.getElementById('MHMobileSearchInput');

  const S_TOGGLE  = document.getElementById('MHSearchToggle');
  const S_CLOSE   = document.getElementById('MHSearchClose');
  const S_INPUT   = document.getElementById('MHSearchInput');
  const S_RESULTS = document.getElementById('MHSearchResults');
  const S_SUGG    = document.getElementById('MHSearchSugg');

  const CART_COUNT = document.getElementById('MHCartCount');

  if (!HDR) return;

  /* ================================================================
     1. SLIM-ON-SCROLL
     ================================================================ */
  const SCROLL_THRESHOLD = 28;
  let ticking = false;

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      HDR.toggleAttribute('data-scrolled', window.scrollY > SCROLL_THRESHOLD);
      ticking = false;
    });
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll(); // run once on load

  /* ================================================================
     2. MEGA-MENU HOVER
     ================================================================ */
  const OPEN_DELAY  = 60;   // ms intent delay before opening
  const CLOSE_DELAY = 130;  // ms grace period after leaving

  let openTimer  = null;
  let closeTimer = null;
  let activeMega = null;

  const megaLayer = document.getElementById('MHMegaLayer');
  const navItems  = HDR.querySelectorAll('.mh-navitem[data-mega]');
  const megaPanels = megaLayer ? megaLayer.querySelectorAll('.mh-mega') : [];

  // Move mega layer to <body> so it escapes any overflow:hidden on Broadcast's
  // section-group wrappers, then use position:fixed with dynamic top tracking.
  if (megaLayer) {
    megaLayer.style.cssText =
      'position:fixed;left:0;right:0;top:0;z-index:9000;pointer-events:none;';
    document.body.appendChild(megaLayer);

    function syncMegaTop() {
      var rect = HDR.getBoundingClientRect();
      megaLayer.style.top = rect.bottom + 'px';
    }
    window.addEventListener('scroll', syncMegaTop, { passive: true });
    window.addEventListener('resize', syncMegaTop, { passive: true });
    syncMegaTop();
  }

  function openMega(key) {
    clearTimeout(closeTimer);
    closeTimer = null;

    if (activeMega === key) return;
    closeAllMegas();

    activeMega = key;

    const item = HDR.querySelector('.mh-navitem[data-mega="' + key + '"]');
    if (item) item.classList.add('is-open');

    const panel = megaLayer ? megaLayer.querySelector('.mh-mega[data-for="' + key + '"]') : null;
    if (panel) {
      panel.classList.add('is-open');
      if (megaLayer) megaLayer.style.pointerEvents = 'auto';
    }
  }

  function closeAllMegas() {
    activeMega = null;
    navItems.forEach(function (el) { el.classList.remove('is-open'); });
    megaPanels.forEach(function (el) { el.classList.remove('is-open'); });
    if (megaLayer) megaLayer.style.pointerEvents = '';
  }

  function scheduleOpen(key) {
    clearTimeout(openTimer);
    clearTimeout(closeTimer);
    closeTimer = null;
    openTimer = setTimeout(function () { openMega(key); }, OPEN_DELAY);
  }

  function scheduleClose() {
    clearTimeout(openTimer);
    openTimer = null;
    closeTimer = setTimeout(closeAllMegas, CLOSE_DELAY);
  }

  navItems.forEach(function (item) {
    const key = item.dataset.mega;
    item.addEventListener('mouseenter', function () { scheduleOpen(key); });
    item.addEventListener('mouseleave', scheduleClose);
    item.addEventListener('focus', function () { openMega(key); });
    item.addEventListener('click', function (e) {
      e.preventDefault();
      if (activeMega === key) {
        closeAllMegas();
      } else {
        openMega(key);
      }
    });
  });

  megaPanels.forEach(function (panel) {
    panel.addEventListener('mouseenter', function () {
      clearTimeout(closeTimer);
      closeTimer = null;
    });
    panel.addEventListener('mouseleave', scheduleClose);
  });

  // Close on click outside
  document.addEventListener('click', function (e) {
    if (!HDR.contains(e.target) && !(megaLayer && megaLayer.contains(e.target))) {
      closeAllMegas();
    }
  });

  // Close on Escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeAllMegas();
      closeSearch();
      closeMobileMenu();
    }
  });

  /* ================================================================
     3. EXPANDING SEARCH + PREDICTIVE SEARCH
     ================================================================ */
  let searchDebounceTimer = null;

  function openSearch() {
    closeAllMegas();
    HDR.setAttribute('data-search-open', '');
    if (S_TOGGLE) S_TOGGLE.setAttribute('aria-expanded', 'true');
    if (S_INPUT) {
      setTimeout(function () { S_INPUT.focus(); }, 50);
    }
  }

  function closeSearch() {
    HDR.removeAttribute('data-search-open');
    if (S_TOGGLE) S_TOGGLE.setAttribute('aria-expanded', 'false');
    if (S_RESULTS) {
      S_RESULTS.hidden = true;
      S_RESULTS.innerHTML = '';
    }
    if (S_SUGG) S_SUGG.style.display = '';
    if (S_INPUT) S_INPUT.value = '';
  }

  if (S_TOGGLE) {
    S_TOGGLE.addEventListener('click', openSearch);
  }

  if (S_CLOSE) {
    S_CLOSE.addEventListener('click', closeSearch);
  }

  if (S_INPUT) {
    S_INPUT.addEventListener('input', function () {
      const q = S_INPUT.value.trim();
      clearTimeout(searchDebounceTimer);

      if (!q) {
        if (S_RESULTS) S_RESULTS.hidden = true;
        if (S_SUGG) S_SUGG.style.display = '';
        return;
      }

      if (S_SUGG) S_SUGG.style.display = 'none';

      searchDebounceTimer = setTimeout(function () {
        fetchPredictive(q);
      }, 220);
    });

    // Submit redirects to search page
    S_INPUT.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && S_INPUT.value.trim()) {
        window.location.href = '/search?q=' + encodeURIComponent(S_INPUT.value.trim()) + '&type=product';
      }
    });
  }

  function fetchPredictive(q) {
    const url = '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=5';

    fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        const products = (data.resources && data.resources.results && data.resources.results.products) || [];
        renderSearchResults(q, products);
      })
      .catch(function () {
        if (S_RESULTS) {
          S_RESULTS.hidden = false;
          S_RESULTS.innerHTML = '<p class="mh-sr-none">Search unavailable — try again.</p>';
        }
      });
  }

  function renderSearchResults(q, products) {
    if (!S_RESULTS) return;

    if (!products.length) {
      S_RESULTS.hidden = false;
      S_RESULTS.innerHTML =
        '<p class="mh-sr-none">No matches for &ldquo;' + escHtml(q) +
        '&rdquo; &mdash; try &ldquo;trucker&rdquo;, &ldquo;250th&rdquo; or &ldquo;tee&rdquo;.</p>';
      return;
    }

    let html = '<p class="mh-sr-lbl">Products</p>';

    products.forEach(function (p) {
      const imgSrc = p.image ? p.image : '';
      const imgTag = imgSrc
        ? '<img src="' + imgSrc + '" alt="' + escHtml(p.title) + '" loading="lazy">'
        : '';

      const price = p.price ? formatMoney(p.price) : '';

      html +=
        '<a class="mh-sr-item" href="' + p.url + '">' +
          '<div class="mh-sr-img">' + imgTag + '</div>' +
          '<div class="mh-sr-info">' +
            '<span class="mh-sr-nm">' + escHtml(p.title) + '</span>' +
            (p.vendor ? '<span class="mh-sr-cat">' + escHtml(p.vendor) + '</span>' : '') +
          '</div>' +
          (price ? '<span class="mh-sr-pr">' + price + '</span>' : '') +
        '</a>';
    });

    S_RESULTS.innerHTML = html;
    S_RESULTS.hidden = false;
  }

  /* ================================================================
     4. MOBILE MENU
     ================================================================ */
  function openMobileMenu() {
    if (!MM) return;
    closeAllMegas();
    MM.hidden = false;
    document.body.style.overflow = 'hidden';
    if (BURGER) BURGER.setAttribute('aria-expanded', 'true');
    // Focus first link for accessibility
    const firstLink = MM.querySelector('a, button');
    if (firstLink) setTimeout(function () { firstLink.focus(); }, 60);
  }

  function closeMobileMenu() {
    if (!MM) return;
    MM.hidden = true;
    document.body.style.overflow = '';
    if (BURGER) BURGER.setAttribute('aria-expanded', 'false');
    if (BURGER) BURGER.focus();
  }

  if (BURGER) {
    BURGER.addEventListener('click', openMobileMenu);
  }

  if (MM_CLOSE) {
    MM_CLOSE.addEventListener('click', closeMobileMenu);
  }

  // Close when a nav link inside mobile menu is clicked
  if (MM) {
    MM.querySelectorAll('.mh-mm-links a').forEach(function (link) {
      link.addEventListener('click', closeMobileMenu);
    });
  }

  // Mobile search → redirect to search page
  if (MM_INPUT) {
    MM_INPUT.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && MM_INPUT.value.trim()) {
        window.location.href = '/search?q=' + encodeURIComponent(MM_INPUT.value.trim()) + '&type=product';
      }
    });
  }

  /* ================================================================
     5. CART COUNT + BADGE BOUNCE
     Listens for Broadcast's cart:updated event (or standard theme events).
     Also listens for Shopify's native section:load and cart AJAX responses.
     ================================================================ */
  function updateCartCount(count) {
    if (!CART_COUNT) return;
    const n = parseInt(count, 10) || 0;
    CART_COUNT.textContent = n;
    if (n > 0) {
      CART_COUNT.removeAttribute('hidden');
    } else {
      CART_COUNT.setAttribute('hidden', '');
    }
  }

  function bounceCartBadge() {
    if (!CART_COUNT) return;
    CART_COUNT.classList.remove('mh-bounce');
    void CART_COUNT.offsetWidth; // reflow to restart animation
    CART_COUNT.classList.add('mh-bounce');
    CART_COUNT.addEventListener('animationend', function () {
      CART_COUNT.classList.remove('mh-bounce');
    }, { once: true });
  }

  // Broadcast theme emits 'cart:updated' with detail.cart
  document.addEventListener('cart:updated', function (e) {
    const count = e.detail && e.detail.cart ? e.detail.cart.item_count : null;
    if (count !== null) {
      bounceCartBadge();
      updateCartCount(count);
    }
  });

  // Also handle add-to-cart via fetch intercept pattern (theme-agnostic)
  document.addEventListener('cart:item-added', function (e) {
    bounceCartBadge();
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartCount(cart.item_count); })
      .catch(function () {});
  });

  // Sync all .mh-cart-count elements (header + mobile menu) via MutationObserver
  if (CART_COUNT) {
    const allCounts = document.querySelectorAll('[id="MHCartCount"], .mh-cart-count');
    // Mirror updates from CART_COUNT to any other count elements
    const mo = new MutationObserver(function () {
      const txt = CART_COUNT.textContent;
      const hidden = CART_COUNT.hasAttribute('hidden');
      allCounts.forEach(function (el) {
        if (el === CART_COUNT) return;
        el.textContent = txt;
        if (hidden) el.setAttribute('hidden', ''); else el.removeAttribute('hidden');
      });
    });
    mo.observe(CART_COUNT, { characterData: true, childList: true, attributes: true });
  }

  /* ================================================================
     6. UTILITIES
     ================================================================ */
  function escHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

function formatMoney(dollars) {
  const amount = parseFloat(dollars).toFixed(2);
  return '$' + amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

})();
